// extracted by mini-css-extract-plugin
module.exports = {"or":"styles_or__39PfW","inputWrap":"styles_inputWrap__13ZXQ","input":"styles_input__3Au8R"};